export const LogoutFlowStates = {
    Close: 'x-close',
    Init: '1-init',
    VerifyingCanLogout: '2-verifying-can-logout',
    ShowingConfirmationModal: '3-showing-confirmation-modal',
    LoggingOut: '4-logging-out',
};
export const LogoutFlowEvents = {
    Close: 'close',
    Logout: 'logout',
    ShowConfirmationModal: 'show-confirmation-modal',
    VerifyCanLogout: 'verify-can-logout',
};
